export const postSyncNewMessageSingular = "Vp2LGc";
export const postSyncNewConversationSingular = "Pr66Sd";
export const postSyncNewMessagefirstPlural = "U2uMfc";
export const postSyncNewConversationfirstPlural = "uKWHBb";
export const postSyncNewMessageSecondPlural = "KrdPxc";
export const postSyncNewConversationSecondPlural = "O0ztQb";
export default {postSyncNewMessageSingular,postSyncNewConversationSingular,postSyncNewMessagefirstPlural,postSyncNewConversationfirstPlural,postSyncNewMessageSecondPlural,postSyncNewConversationSecondPlural};